import "./Modal.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import ReactDom from "react-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { useEffect, useState } from "react";
import InputText from "core/inputs/input-text/InputText";
import InputSelect from "core/inputs/input-select/InputSelect";

const SalaryValidationModal = ({
  open,
  onClose,
  warning,
  onSubmit,
  coefOptions,
  onCancel,
}) => {
  const intl = useIntl();
  const [salary, setSalary] = useState("");
  const [coef, setCoef] = useState("");
  const handleCoefChange = (_name, newValue) => {
    setCoef(newValue);
  };
  const handleCancel = () => {
    onCancel?.();
    onClose?.();
  };
  useEffect(() => {
    if (!open || !warning) return;
    setSalary(warning.base_salary ?? "");

    const matched = coefOptions.find(
      (opt) => opt.lb === warning.current_coef_position
    );
    setCoef(matched?.val ?? (current_coef_position || ""));
  }, [open]);

  if (!open || !warning) return null;

  const {
    current_coef_position,
    minimum_salary,
    current_salary,
    base_salary,
    bonus,
  } = warning || {};

  const handleValidate = () => {
    onSubmit({
      salary,
      coef,
    });
  };

  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div className="backup-modal-style evaluate-modal-custom-width salary-validation-modal">
        <div className="header">
          <div className="title">
            {intl
              .formatMessage({
                id: "salary_validation_title",
                defaultMessage: "Validation du salaire",
              })
              .toUpperCase()}
          </div>
          <Icon color="gray-200" icon="close" onClick={handleCancel} />
        </div>

        <div className="body">
          <div className="modal-section">
            <p className="modal-section-title">
              <strong>
                <FormattedMessage
                  id="salary_validation_warning_prefix"
                  defaultMessage="Attention !"
                />
              </strong>{" "}
              <FormattedMessage
                id="salary_validation.warning_text"
                defaultMessage="Le salaire minimum pour le coefficient {coef} est {minSalary}€. 
                Le salaire actuel du consultant est {currentSalary}€ ({base}€ + bonus {bonus}€)."
                values={{
                  coef: <strong>{current_coef_position}</strong>,
                  minSalary: <strong>{minimum_salary.toFixed(2)}</strong>,
                  currentSalary: <strong>{current_salary.toFixed(2)}</strong>,
                  base: <strong>{base_salary.toFixed(2)}</strong>,
                  bonus: <strong>{bonus}</strong>,
                }}
              />
            </p>
          </div>

          <hr className="modal-divider" />

          <div className="input-group-options">
            <div className="input-row">
              <label htmlFor="salary-validation-salary" className="input-label">
                <FormattedMessage
                  id="salary_validation.update_salary"
                  defaultMessage="Mettre à jour le salaire ?"
                />
              </label>
              <InputText
                id="salary-validation-salary"
                errors={{}}
                type="number"
                value={base_salary}
                onChange={(e) => setSalary(e.target.value)}
                placeholder={{
                  id: "salary_validation.salary_placeholder",
                  defaultMessage: "Nouveau salaire",
                }}
              />
            </div>

            <div className="input-row">
              <label htmlFor="salary-validation-coef" className="input-label">
                <FormattedMessage
                  id="salary_validation.update_coef"
                  defaultMessage="Mettre à jour le coefficient ?"
                />
              </label>
              <InputSelect
                id="salary-validation-coef"
                options={coefOptions}
                name="coef"
                setValue={handleCoefChange}
                value={coef}
                hasCategoryTag={true}
              />
            </div>
          </div>

          <div className="form-buttons">
            <Button
              className="btn-standard btn-outline"
              onClick={handleCancel}
              type="button"
              id="button-salary-modal-cancel"
            >
              <FormattedMessage id="cancel" defaultMessage="Fermer" />
            </Button>
            <Button
              color="btn-medium gray-700"
              type="submit"
              onClick={handleValidate}
              id="button-salary-modal-validate"
            >
              <FormattedMessage id="validate" defaultMessage="Valider" />
            </Button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default SalaryValidationModal;
